import { BrowserRouter, Route, Routes} from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "./style.css";
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css';
import Normateca from './componentes/Normateca';

function App() {
  const basename = "/";  
  return (
    <>
     <BrowserRouter basename={basename}>
          <Routes>
            <Route path='/app/normateca/default.html' element={<Normateca param="Inicio"/>} key="normateca" exact={true}/>
            <Route path='/' element={<Normateca param="Inicio"/>} key="/" exact={true} />
            <Route path='*' element={<Normateca param="Inicio"/>} key="*"/> 
            <Route path= '/app/normateca/masinfo'  element={<Normateca param="masInfo" />} key={"masinfo"} exact={true} />
            <Route path='/app/normateca/:datos' element={<Normateca param="otro"/>} key="b" />
            <Route path='/app/normateca/busAvaOpc' element={<Normateca param="busAvaOpc"/>} key="ba" exact={true} />

           {/*  <Route path='/app/normateca/bus/:datos' element={<Normateca param="bus"/>} key="b" />
            <Route path='/app/normateca/busAva/:datos' element={<Normateca param="busAva"/>} key="badat" />
            <Route path='/app/normateca/menu/:datos' element={<Normateca  param="menu"/>} /> */}
           </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" theme='colored' />
    </>
  );
}export default App;
